export interface Insurer {
  code?: string;
}

export interface InsurerData {
  dossierId?: number;
  callAgent?: string;
  callAgentFirstname?: string;
  callAgentLastname?: string;
  comment?: string;
  other?: string;
  abandonmentComment?: string;
  finishLaterComment?: string;
  rriNumber?: string;
}
